// src/router.js
import { createRouter, createWebHashHistory } from "vue-router";
import MainView from "./components/MainView.vue";

const routes = [
    {
    path: "/introduction-to-robotics-2025-2026",
    name: "introduction-to-robotics-2025-2026",
    component: MainView,
    props: { bucketName: "introduction-to-robotics", version: "Version 2025-2026" },
  },
  {
    path: "/introduction-to-robotics-2024-2025",
    name: "introduction-to-robotics-2024-2025",
    component: MainView,
    props: { bucketName: "introduction-to-robotics", version: "Version 2024-2025" },
  },
  {
    path: "/introduction-to-robotics-2023-2024",
    name: "introduction-to-robotics-2023-2024",
    component: MainView,
    props: { bucketName: "introduction-to-robotics", version: "Version 2023-2024" },
  },
  {
    path: "/introduction-to-robotics-2022-2023",
    name: "introduction-to-robotics-2022-2023",
    component: MainView,
    props: { bucketName: "introduction-to-robotics", version: "Version 2022-2023" },
  },
  {
    path: "/taking-off-with-pilot-2024-2025",
    name: "taking-off-with-pilot-2024-2025",
    component: MainView,
    props: { bucketName: "taking-off-with-pilot", version: "Version 2024-2025" },
  },
  {
    path: "/taking-off-with-pilot-2023-2024",
    name: "taking-off-with-pilot-2023-2024",
    component: MainView,
    props: { bucketName: "taking-off-with-pilot", version: "Version 2023-2024" },
  },
  {
    path: "/taking-off-with-pilot-2025-2026",
    name: "taking-off-with-pilot-2025-2026",
    component: MainView,
    props: { bucketName: "taking-off-with-pilot", version: "Version 2025-2026" },
  },
  {
    path: "/paving-the-way-2025-2026",
    name: "paving-the-way-2025-2026",
    component: MainView,
    props: { bucketName: "paving-the-way", version: "Version 2025-2026" },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
